import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Title, View } from '@common/components';
import { Row, Col, Layout } from 'antd';
import { Helmet } from 'react-helmet';
import { fetchOrganization } from '@common/resources/Organization/actions';
import {
	fetchStorages,
	fetchStoragesByOrganization,
	clearStorages,
} from '@resources/Storage/actions';
import { FormattedMessage, useIntl } from 'react-intl';
import { StorageItem } from '@fragments/items';
import CreateModal from './Create';
import UpdateModal from './Update';

const { Content } = Layout;

const Storage = (props) => {
	const {
		storages,
		fetchStorages,
		fetchStoragesByOrganization,
		clearStorages,
		organization,
		history,
	} = props;
	const intl = useIntl();
	const [create, setCreate] = useState(false);
	const [update, setUpdate] = useState(false);

	useEffect(() => {
		const func = async () => {
			await clearStorages();

			organization?._id
				? await fetchStoragesByOrganization(organization?._id)
				: await fetchStorages();
		};

		func();
	}, [
		fetchStorages,
		fetchStoragesByOrganization,
		clearStorages,
		organization,
	]);

	const parseDataSource = useCallback(() => {
		return storages.map((storage) => {
			return {
				key: storage._id,
				...storage,
			};
		});
	}, [storages]);

	const handleClick = (storage) => {
		history.push(
			`/${storage.organization.alias}/storages/${storage._id}/details`
		);
	};

	return (
		<Content>
			<Helmet>
				<title>
					{intl.formatMessage({
						id: 'common.storage.management',
						defaultMessage: 'Storage Management',
					})}
				</title>
			</Helmet>
			<CreateModal
				{...props}
				module={module}
				visible={create}
				onCancel={() => setCreate(false)}
			/>

			<UpdateModal
				{...props}
				module={module}
				visible={update}
				onCancel={() => setUpdate(false)}
			/>
			<Container>
				<View>
					<Row
						type="flex"
						justify="center"
						align="middle"
						className="mt-5">
						<Col md={{ span: 12 }}>
							<Title>
								<FormattedMessage
									id="common.storages"
									defaultMessage="Storages"
								/>
							</Title>
						</Col>
						<Col md={{ span: 12 }} className="text-right">
							<Button
								type="primary"
								onClick={() => setCreate(true)}>
								<FormattedMessage
									id="common.new.storage"
									defaultMessage="New Storage"
								/>
							</Button>
						</Col>
					</Row>
					{parseDataSource() &&
						parseDataSource().map((storage, index) => (
							<StorageItem
								key={`storage-${index}`}
								storage={storage}
								onEdit={() => setUpdate(storage._id)}
								onClick={handleClick}
							/>
						))}
				</View>
			</Container>
		</Content>
	);
};

const mapStateToProps = ({
	storages,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	storage,
}) => {
	return {
		storages,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		storage,
	};
};

export default connect(mapStateToProps, {
	fetchOrganization,
	fetchStorages,
	fetchStoragesByOrganization,
	clearStorages,
})(Storage);
